
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M58.25 140.24c-12.69 2.69-27.31 11.54-35.38 21.73-14.04 17.89-13.08-7.31-12.69 354.22l.58 324.99 4.42 6.35c2.5 3.46 7.31 7.69 10.58 9.62 5.77 3.08 29.61 3.27 384.98 3.85 208.45.38 383.45 0 389.21-.58 8.46-1.15 11.73-2.69 17.69-8.27 6.73-6.73 12.5-21.35 90.19-229.03 72.69-194.04 83.07-222.89 82.11-229.62-1.16-8.46-5.58-15.38-13.66-21.35-5-3.85-8.08-4.04-77.3-4.62l-71.92-.58v-74.22L821.29 281c-6.34-12.5-14.61-20.96-27.5-27.69l-8.08-4.42-222.3-.58-222.49-.39-.77-32.31c-.58-28.46-1.15-33.08-4.81-40.77-7.11-14.23-15.19-22.5-29.04-29.23l-12.88-6.35-113.46-.39c-62.29-.17-117.09.6-121.71 1.37zm222.68 91.34c.96 30.58 1.35 33.27 6.15 42.5 6.15 11.54 17.88 22.69 30.19 28.46l8.85 4.04 220.76.58 220.57.38v59.62h-284.6c-313.06 0-295.18-.58-303.83 11.54-1.92 2.69-27.11 67.88-55.96 144.42-28.66 76.52-52.5 139.6-52.89 139.98-.38.38-.77-104.03-.77-232.1V197.93l105.38.38 105.19.58.96 32.69zm636.51 195.57c0 .38-31.54 84.42-70 187.11l-69.99 186.53-347.29.38c-190.95 0-347.29 0-347.29-.19 0-.38 132.3-353.64 138.26-369.02l2.12-5.19h347.1c190.95 0 347.09.19 347.09.38z"}})])
          )
        }
      }
    